"use client";
import React from "react";
import { DatePicker as AntdDatePicker } from "antd";
import { useField, useFormikContext } from "formik";
import cx from "classnames";
import dayjs, { Dayjs } from "dayjs";

interface DatePickerProps {
  name: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
  [key: string]: unknown;
}

const DatePicker: React.FC<DatePickerProps> = ({
  name,
  label,
  placeholder,
  disabled = false,
  className,
  labelClassName,
  ...props
}) => {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();

  const handleChange = (date: Dayjs) => {
    setFieldValue(name, date);
  };

  return (
    <div className={cx("flex flex-col", className)}>
      {label && (
        <label
          htmlFor={name}
          className={cx("text-sm font-medium text-gray-700", labelClassName)}
        >
          {label}
        </label>
      )}
      <AntdDatePicker
        id={name}
        placeholder={placeholder}
        disabled={disabled}
        className={className}
        status={meta.touched && meta.error ? "error" : ""}
        value={field.value ? dayjs(field.value) : null}
        onChange={handleChange}
        {...props}
      />
      {meta.touched && meta.error && (
        <span className="text-xs text-red-500">{meta.error}</span>
      )}
    </div>
  );
};

export default DatePicker;
